import Button from "../../../../miscellaneous/Button";
import { ButtonTheme } from "../../../../miscellaneous/ButtonTheme";

export interface LoadingDashboardProps {
  /**
   * Whether the wallet is connecting or not.
   */
  isConnecting: boolean;
  /**
   * The function to call when the user wants to connect the wallet.
   */
  connectWallet: () => void;
}

export default function LoadingDashboard(props: LoadingDashboardProps) {
  return (
    <div
      data-aos="fade-left"
      className="self-center w-fit flex md:flex-row flex-col md:items-start items-center justify-center"
    >
      <div className="flex flex-col items-start animate-pulse">
        <div className="bg-gradient-to-br from-silver to-emperor ~rounded-md/lg ~w-20/24 ~h-3/4 mb-3" />
        <div className="bg-gradient-to-br from-silver to-emperor ~rounded-md/lg ~w-40/48 ~h-7/9 mb-3" />
        <div className="bg-gradient-to-br from-silver to-emperor ~rounded-md/lg ~w-28/36 ~h-8/10 mb-5" />
        <div className="bg-gradient-to-br from-silver to-emperor ~rounded-md/lg ~w-56/72 ~h-3/4" />
      </div>
      <div className="md:~w-12/20 w-0 md:h-0 ~h-8/12"></div>
      <div className="flex flex-col items-start animate-pulse">
        <div className="bg-gradient-to-br from-silver to-emperor ~rounded-md/lg w-44 ~h-3/4 mb-3" />
        <div className="bg-gradient-to-br from-silver to-emperor ~rounded-md/lg w-56 ~h-4/6 mb-2" />
        <div className="bg-gradient-to-br from-silver to-emperor ~rounded-md/lg w-56 ~h-4/6 mb-2" />
        <div className="bg-gradient-to-br from-silver to-emperor ~rounded-md/lg w-56 ~h-4/6 mb-3" />
        <div className="bg-gradient-to-br from-silver to-emperor ~rounded-md/lg w-24 ~h-3/4 self-end" />
      </div>
      <div className="absolute md:~top-10/12 top-30">
        <Button
          text={"CONNECT"}
          enabled={true}
          loading={props.isConnecting}
          theme={ButtonTheme.PersianPink}
          onClick={function (): void {
            props.connectWallet();
          }}
        ></Button>
      </div>
    </div>
  );
}
